// whitelist-html.service.ts
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SafeHtmlService {
    private allowedTags = ['b', 'i', 'u', 'a', 'p', 'br', 'strong', 'em', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
    private allowedAttrs = ['href', 'title', 'target'];

    sanitize(html: string): string {
        if (!html) return '';

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        this.cleanNode(doc.body);
        return doc.body.innerHTML; // gibt reinen bereinigten HTML-String zurück
    }

    private cleanNode(node: HTMLElement) {
        const children = Array.from(node.children);
        for (const child of children) {
            const tag = child.tagName.toLowerCase();

            if (!this.allowedTags.includes(tag)) {
                child.remove();
                continue;
            }

            const attributes = Array.from(child.attributes);
            for (const attr of attributes) {
                if (!this.allowedAttrs.includes(attr.name.toLowerCase())) {
                    child.removeAttribute(attr.name);
                }
            }

            this.cleanNode(child as HTMLElement);
        }
    }
}
